export default __webpack_public_path__ + "static/logo33-a2d06b0fa64ecdd8f25b03bc97fc4bf5.png";